export const GoogleAnalyticsIds = {
    SEARCH_MODAL_NO_RESULTS: "search-modal-no-results",
    SEARCH_RESULT_CARD: "search-result-card",
    SEARCH_MODAL_PAGE_NAVIGATION: "search-modal-page-navigation",
    REFERENCE_PANEL_GO_TO_LINK: "reference-panel-go-to-link",
    REFERENCE_PANEL_CLEAR_ALL_BUTTON: "reference-panel-clear-all-button",
    REFERENCE_PANEL_DELETE_BUTTON: "reference-panel-delete-button",
};
